import { DatePipe } from '@angular/common';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ConstantsService {
  constructor(private datePipe: DatePipe){
        
  }
  //readonly ApiUrl: string = 'https://api.chemrobotics.com/';
  readonly ApiUrl: string = environment.appUrl;
  displayUsername: string = "";
  accessKey: string = "";
  isLoggedIn: boolean = false;
  readonly defaultuser:string=environment.defaultuser;
  readonly defaultkey:string=environment.defaultkey;
  prodData:any;

  GoToMainUrl()
  {
      window.location.href = 'https://www.chemrobotics.com/';
  }

  getTablesqlFilterCondition(filterdata:any):string{
      let filtercondition_sql="";
      if(filterdata){
          let filterconditions:string[]=[];        
          Object.keys(filterdata).forEach(item=>{
             let columnname=item;
             let filterconditions_temp=[];
             let filterconditionvalue= null;
             if(Array.isArray(filterdata[item])){
                 let arrayconditions=filterdata[item];
                 arrayconditions.forEach(element => {
                  if(element.value){
                      filterconditions_temp.push({filterconditionvalue:element.value,matchMode: element.matchMode});
                  }
                 });                
             }
             else{
              filterconditions_temp.push({filterconditionvalue:filterdata[item].value,matchMode: filterdata[item].matchMode});
             }

             filterconditions_temp.forEach(item=>{
              let makcondition="";
              if(item.filterconditionvalue){
                  switch (item.matchMode) {
                      case "startsWith":
                       makcondition=`${columnname} LIKE ''${item.filterconditionvalue}%''`;
                       break;
                       case "endsWith":
                           makcondition=`${columnname} LIKE ''%${item.filterconditionvalue}''`;
                       break;
                       case "contains":
                           if((item.filterconditionvalue instanceof Date)){
                              item.filterconditionvalue=this.datePipe.transform(item.filterconditionvalue,"yyyy-MM-dd")
                           }
                           makcondition=`${columnname} LIKE ''%${item.filterconditionvalue}%''`;
                       break;
                       case "notContains":
                           makcondition=`${columnname} NOT LIKE ''%${item.filterconditionvalue}%''`;
                       break;
                       case "equals":
                           makcondition=`${columnname} = ''${item.filterconditionvalue}''`;
                       break;
                       case "notEquals":
                           makcondition=`${columnname} != ''${item.filterconditionvalue}''`;
                       break;
                       case "dateAfter":
                           makcondition=`${columnname} > ''${this.datePipe.transform(item.filterconditionvalue,"yyyy-MM-dd")}''`;
                       break;
                       case "dateBefore":
                           makcondition=`${columnname} < ''${this.datePipe.transform(item.filterconditionvalue,"yyyy-MM-dd")}}''`;
                       break;
                       case "dateIsNot":
                           makcondition=`${columnname} != ''${this.datePipe.transform(item.filterconditionvalue,"yyyy-MM-dd")}}''`;
                       break;
                       
                      default:
                       makcondition=`1=1`
                          break;
                  }
   
                  filterconditions.push(makcondition);
              }
             });
             
          });
  
          filtercondition_sql=filterconditions.length>0 ? ' AND ('+filterconditions.join(" AND ")+')' : "";
      }
      

      return filtercondition_sql;
  }

  getAppprivilege(privilege_json:any, appname: string, userid: number) {
      if (privilege_json) {
        let privilegetemp = JSON.parse(privilege_json);
        let priv_app=privilegetemp[`user_${userid}`][appname];
        if(priv_app){
          priv_app['View']=priv_app['View']=="true";
          priv_app['Download']=priv_app['Download']=="true";
          priv_app['Search']= (priv_app['Search'] >>> 0);
          priv_app['DownloadCount']= (priv_app['DownloadCount'] >>> 0);
          priv_app['DailySearchLimit']= (priv_app['DailySearchLimit'] >>> 0);
          priv_app['DailyDownloadLimit']= (priv_app['DailyDownloadLimit'] >>> 0);
          priv_app['InitialSearchCount']= (priv_app['InitialSearchCount'] >>> 0);
          priv_app['InitialDownloadCount']= (priv_app['InitialDownloadCount'] >>> 0);
          return privilegetemp[`user_${userid}`][appname];
        }else{
          return "";
        }          
      }
      return "";
    }
}
